import React, { Fragment, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import flow from 'lodash/fp/flow';
import filter from 'lodash/fp/filter';
import map from 'lodash/fp/map';
import get from 'lodash/get';
import './ProjectView.css';
import pencil from './Edit.svg';
import _ from 'lodash';
import { ReferencesCard } from './ReferenceCard/ReferenceCard';
import DraftModal from './DraftModal/DraftModal';
import fileIcon from './fileIcon.svg';
import dropboxIcon from './dropbox-icon.svg';
import toolTipIcon from './tool_tip.svg';
import { humanize } from '../../shared/helpers';
import File from './File/File';
import { Button } from '../Button';
import DatePicker from 'react-date-picker';
import { Form, withFormik, FieldArray } from 'formik';
import { Input as FormInput } from '../../components/Form/Input';
import { Dropdown as FormDropdown } from '../Form';
import { withInputClassNames, withTextAreaClassNames } from './HOC';
import * as Yup from 'yup';
import { AvatarChooser } from '../Form/AvatarChooser';
import { withDropdownClassNames } from '../EditProfile/HOC';
import moment from 'moment';
import classnames from 'classnames';
import { DropboxChooser } from '../DropboxChooser';
import './ProjectViewMobile.css';
import ConnectFiles from './ConnectFiles/ConnectFiles';
import check from '../EditProfileMobile/Check.svg';
import cross from '../EditProfileMobile/Cross.svg';
import ProfilePic from '../Header/profile-pic.svg';

const Input = withInputClassNames(FormInput);
const TextArea = withTextAreaClassNames(FormInput);
const Dropdown = withDropdownClassNames(FormDropdown);

const ProjectView = ({
  project: { references },
  handleSubmitDraft,
  handleEditAction,
  getNotRequired,
  getaudRequired,
  video_layoutRequired,
  manager,
  pageState,
  getResponses,
  getFormats,
  getLabels,
  project,
  handleAddProjectFileResources,
  children,
  updateFormInfo,
  emailConfirmed,
  email,
  submitForm,
  formInfo,
  currentOnboardingSteps,
  dispatchProjectFileUpload,
  dispatchResendConfirmation,
}) => {
  const stepList = [
    'files',
    'deadline',
    'basic_requirements',
    'series',
    'project_requirements',
    'type',
    'duration',
    'audience',
    'video_layout',
  ];

  const [resent, setResent] = useState(false);

  const allSteps = project.project_onboarding_infos.filter(info =>
    stepList.includes(info.question.key),
  );
  const answeredSteps = allSteps.filter(
    step => step.question_response.length !== 0,
  );
  const briefProgress =
    parseFloat(answeredSteps.length) / parseFloat(allSteps.length);

  const fileState = get(
    project.project_onboarding_infos.find(
      info => get(info, 'question.key') === 'files',
    ),
    'question_response[0]',
  );

  const fileStates = {
    DROPBOX: fileState === 'dropbox',
    NO_FILES: fileState === 'no_files',
    DIFFERENT_WAY: fileState === 'different_way',
  };

  const handleSelectResources = selectedResources => {
    const urls = selectedResources.map(resource => resource.link);

    if (urls) {
      handleAddProjectFileResources(urls);
    }
  };

  const getAnimationValue = value => {
    if (value !== 'Animation') return value;

    return `${value}/${getResponses('animation')(getLabels)}`;
  };

  const notification = !emailConfirmed && (
    <div
      className={`col-12 confirm-notification ${manager &&
        'notification-with-manager-header'}`}
    >
      <p className="t-14">
        Your account has not been validated yet. Click on the link we sent to{' '}
        {email}.
      </p>
      <button
        disabled={resent}
        onClick={() => {
          setResent(true);
          dispatchResendConfirmation(email);
        }}
        className="btn btn-next"
      >
        {resent ? 'Email Sent! ' : 'Resend Confirmation'}
      </button>
    </div>
  );

  const advRequirementsBlock = useRef(null);
  const basicRequirementsBlock = useRef(null);

  const basic_needs = getResponses('basic_requirements')(getLabels).map(
    need => {
      if (need === 'Animation') {
        const animationDetails = getResponses('animation')(getLabels)[0]
          ? ` - ${getResponses('animation')(getLabels)[0]}`
          : '';
        return (
          <p key={need} className="t-14 text-black m-0">
            {`Animation${animationDetails}`}
          </p>
        );
      }
      return (
        <p key={need} className="t-14 text-black m-0">
          {need}
        </p>
      );
    },
  );
  console.log(notification);
  return (
    <div
      className={`project-view-page ${manager &&
        'page-with-manager-header'} ${notification &&
        'page-with-notification'}`}
    >
      {notification}
      {children}
      <div
        className={`container project-view-container ${notification &&
          'with-notification'} ${manager && 'with-manager-header'}`}
      >
        <div
          className="row"
          style={{ paddingTop: !emailConfirmed ? '40px' : '60px' }}
        >
          <div className="col-12 col-lg-3 brief-progress">
            <BriefProgressBar
              allCards={allSteps}
              answeredCards={answeredSteps}
              stepList={stepList}
              progress={briefProgress}
              advRequirementsBlock={advRequirementsBlock}
              basicRequirementsBlock={basicRequirementsBlock}
              handleEditAction={handleEditAction}
            />
            <div className="row my-5">
              <div className="project-basic-info">
                <div className="bg-white shadow-mid p-3">
                  <ProjectNameFormWithFormik
                    project={project}
                    pageState={pageState}
                    submitForm={submitForm}
                    updateFormInfo={updateFormInfo}
                    handleEditAction={handleEditAction}
                    formInfo={formInfo}
                    action="editTitle"
                  />
                  <div className="col-12">
                    <ProjectPictureFormWithFormik
                      project={project}
                      formInfo={formInfo}
                      updateFormInfo={updateFormInfo}
                      submitForm={submitForm}
                    />
                  </div>
                  <div className="col-12">
                    <h5 className="t-14 text-gray-light mt-4 mb-4">
                      An Account Manager{' '}
                      {_.isEmpty(project.manager) &&
                        ' will be assigned once your brief is approved.'}
                    </h5>
                    {!_.isEmpty(project.manager) && (
                      <React.Fragment>
                        <div className="col d-flex align-items-center manager-info">
                          <div
                            className="nav-item-avatar-md manager-avatar"
                            style={{
                              backgroundImage: `url(${project.manager
                                .avatar_url || ProfilePic})`,
                            }}
                          />
                          <div className="details manager-details ml-2">
                            <p className="t-15 mb-0 text-capitalize text-gray-mate mb-0">
                              {project.manager.name}
                            </p>
                            <p className="t-12 mb-0 text-uppercase text-dark-teal cursor-pointer  font-weight-mid">
                              <a href={`mailto:${project.manager.email}`}>
                                {email}
                              </a>
                            </p>
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="row my-5">
              <div className="drafts">
                <div className="bg-white shadow-mid w-100 p-4 align-self-stretch">
                  <div className="row">
                    <div className="col-12 draft-content">
                      <p className="t-21 text-darkgreen mb-0">Drafts</p>
                      {project.drafts.filter(
                        draft => draft.status !== 'not_started',
                      ).length !== 0 && (
                        <div className="tooltip-item">
                          <div className="tooltip">
                            <p>
                              Click on the link to be directed to{' '}
                              <a href="https://wipster.io" target="_blank">
                                Wipster.io
                              </a>
                              {` `}
                              where you can see your draft video and provide
                              notes right on the video itself. You will need to
                              create an account to provide notes.
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="col-12">
                      <div className="col p-0 mt-4">
                        <hr />
                      </div>
                    </div>
                  </div>
                  {project.status != 'pending' && (
                    <DraftModal
                      project={project}
                      onSubmit={handleSubmitDraft}
                    />
                  )}
                  {project.status == 'pending' && (
                    <div className="row">
                      <div className="col">
                        <p className="t-14 text-gray-light my-4">
                          Once your project is underway, access drafts here.
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row my-4 px-4 support-desktop">
              <p className="t-14 font-weight-bold text-darkgreen">Support</p>
              <h5 className="t-14 text-darkgreen">
                Questions about the process or have more advanced requirements?
              </h5>
              <h5 className="t-14 text-darkgreen">
                Email us at{' '}
                <a href="mailto:shari@dreamitreel.com">shari@dreamitreel.com</a>
                <br />
                or call <a href="tel:855-431-7335">(855) 431-7335</a>
              </h5>
            </div>
          </div>
          <div className="col-12 col-lg-9 my-4 project-info">
            <div className="row m-4">
              <div className="col-12 p-0">
                <div
                  className="bg-white shadow-mid p-4"
                  ref={basicRequirementsBlock}
                >
                  <ProjectDetailsFormWithFormik
                    project={project}
                    pageState={pageState}
                    submitForm={submitForm}
                    updateFormInfo={updateFormInfo}
                    handleEditAction={handleEditAction}
                    formInfo={formInfo}
                    action="editBasic"
                    getResponses={getResponses}
                    getLabels={getLabels}
                    basic_needs={basic_needs}
                    onboardingSteps={currentOnboardingSteps}
                    basicRequirementsBlock={basicRequirementsBlock}
                  />
                </div>
              </div>
            </div>
            <div className="row ml-4 pt-4 advanced-requirements-title">
              <h1 className="t-24 text-darkgreen">Advanced Requirements</h1>
            </div>
            <div className="row ml-4 mr-4">
              <div className="col-12 p-0 my-4" ref={advRequirementsBlock}>
                <div className="bg-white shadow-mid p-4 pb-5 advanced-requirements-body">
                  <ProjectAdditionalInfoFormWithFormik
                    dispatchProjectFileUpload={dispatchProjectFileUpload}
                    getResponses={getResponses}
                    getLabels={getLabels}
                    project={project}
                    onboardingSteps={currentOnboardingSteps}
                    pageState={pageState}
                    submitForm={submitForm}
                    updateFormInfo={updateFormInfo}
                    handleEditAction={handleEditAction}
                    formInfo={formInfo}
                    action="editAdditionalInfo"
                  />
                  <ProjectReferencesFormWithFormik
                    project={project}
                    pageState={pageState}
                    submitForm={submitForm}
                    references={references}
                    updateFormInfo={updateFormInfo}
                    handleEditAction={handleEditAction}
                    formInfo={formInfo}
                    action="editReferences"
                  />
                </div>
              </div>
            </div>
            <div className="row my-4 px-4 support-mobile">
              <p className="t-14 font-weight-bold text-darkgreen">Support</p>
              <h5 className="t-14 text-darkgreen">
                Questions about the process or have more advanced requirements?
              </h5>
              <h5 className="t-14 text-darkgreen">
                Email us at{' '}
                <a href="mailto:shari@dreamitreel.com">shari@dreamitreel.com</a>
                <br />
                or call <a href="tel:855-431-7335">(855) 431-7335</a>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const FormActions = ({
  pageState,
  action,
  handleEditAction,
  updateFormInfo,
  project,
}) => {
  if (pageState[action]) {
    return (
      <React.Fragment>
        <div className="form-actions desktop-actions">
          <div className="form-actions__container">
            <Button
              className="btn btn-md t-14 btn-primary"
              type="submit"
              title="Save"
            />
            <Button
              title="Cancel"
              className="btn btn-md t-14 btn-back"
              onClick={() => {
                if (action === 'editReferences')
                  updateFormInfo({
                    target: {
                      name: 'references',
                      value: _.cloneDeep(project.references),
                    },
                  });
                handleEditAction(action);
              }}
            />
          </div>
        </div>
        <div className="form-actions mobile-actions">
          <div className="form-actions__container">
            <Button className="btn btn-md t-14 btn-primary" type="submit">
              <i
                className="icon m-0"
                style={{
                  backgroundImage: `url(${check})`,
                  backgroundSize: 'auto',
                  backgroundRepeat: 'no-repeat',
                }}
              />
            </Button>
            <Button
              className="btn btn-md t-14 btn-back"
              onClick={() => handleEditAction(action)}
            >
              <i
                className="icon m-0"
                style={{
                  backgroundImage: `url(${cross})`,
                  backgroundSize: 'auto',
                  backgroundRepeat: 'no-repeat',
                }}
              />
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }
  return (
    <i
      className="cursor-pointer icon m-0 text-gray-light t-20"
      style={{
        backgroundImage: `url(${pencil})`,
        backgroundSize: 'auto',
        backgroundRepeat: 'no-repeat',
      }}
      onClick={() => handleEditAction(action)}
    />
  );
};

class BriefProgressBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fillingSession: true,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.answeredCards.length !== this.props.stepList.length &&
      this.props.answeredCards.length === this.props.stepList.length
    ) {
      this.setState({
        fillingSession: false,
      });
    }
  }

  render() {
    const {
      allCards,
      answeredCards,
      stepList,
      progress,
      advRequirementsBlock,
      basicRequirementsBlock,
      handleEditAction,
    } = this.props;
    const basicRequirementsSteps = ['basic_requirements', 'type', 'duration'];

    const filledBasics = answeredCards.filter(card =>
      basicRequirementsSteps.includes(card.question.key),
    );

    const advancedRequirementsSteps = [
      'files',
      'deadline',
      'series',
      'project_requirements',
      'audience',
      'video_layout',
    ];

    const filledAdvanced = answeredCards.filter(card =>
      advancedRequirementsSteps.includes(card.question.key),
    );

    let briefProgressText;

    if (filledBasics.length !== basicRequirementsSteps.length)
      briefProgressText = (
        <React.Fragment>
          <h5 className="t-14 text-darkgreen my-2">
            Thank you! Let us know more about the kind of video you want to
            create:
          </h5>
          <a
            className="t-14"
            href="/"
            onClick={e => {
              e.preventDefault();
              window.scrollTo(
                0,
                basicRequirementsBlock.current.offsetTop +
                  basicRequirementsBlock.current.offsetHeight,
              );
              handleEditAction('editBasic');
            }}
          >
            Fill out Basic Requirements
          </a>
        </React.Fragment>
      );
    else if (filledAdvanced.length === 0)
      briefProgressText = (
        <React.Fragment>
          <h5 className="t-14 text-darkgreen my-2">
            Well done! Now we have the basics of your creative brief. For a more
            detailed assessment, please complete the Advanced Requirements
            section.
          </h5>
          <a
            className="t-14"
            href="/"
            onClick={e => {
              e.preventDefault();
              window.scrollTo(
                0,
                advRequirementsBlock.current.offsetTop +
                  advRequirementsBlock.current.offsetHeight,
              );
              handleEditAction('editAdditionalInfo');
            }}
          >
            Fill out Advanced Requirements
          </a>
        </React.Fragment>
      );
    else if (filledAdvanced.length !== advancedRequirementsSteps.length)
      briefProgressText = (
        <h5 className="t-14 text-darkgreen my-2">
          Getting there! The more you share about your project, the better we
          can understand your needs.
        </h5>
      );
    else if (
      !this.state.fillingSession &&
      filledAdvanced.length === advancedRequirementsSteps.length
    )
      briefProgressText = (
        <h5 className="t-14 text-darkgreen my-2">
          You’re awesome. We appreciate your filling out more information, and
          will now have so much more to cover when we connect you with your
          team.
        </h5>
      );
    else briefProgressText = 'no text at all';

    return (
      (stepList.length !== answeredCards.length ||
        !this.state.fillingSession) && (
        <div className="row mt-5 mb-4 px-4 brief-progress-bar">
          <p className="t-14 font-weight-bold text-darkgreen mb-1">
            Brief Progress
          </p>
          <div className="progress-bar mb-4 mt-1">
            <div
              style={{ width: `${progress ? 100 * progress : 0}%` }}
              className="progress"
            />
          </div>
          {briefProgressText}
        </div>
      )
    );
  }
}

const ProjectNameForm = props => {
  const {
    pageState,
    action,
    handleEditAction,
    project: { project_name },
    updateFormInfo,
    submitForm,
  } = props;

  return (
    <SimpleForm {...props}>
      <div
        className={classnames(
          'row mb-3 px-2 mx-2 justify-content-between align-items-center',
          { 'project-name-with-buttons': pageState[action] },
        )}
      >
        {pageState[action] ? (
          <Input
            label="Project Name"
            name="projectName"
            onChange={updateFormInfo}
            hasInput={!!project_name}
          />
        ) : (
          <React.Fragment>
            <div className="col-10 p-0">
              <p className="t-21 text-darkgreen project-name">{project_name}</p>
            </div>
          </React.Fragment>
        )}
        <FormActions
          pageState={pageState}
          action={action}
          handleEditAction={handleEditAction}
          submitForm={submitForm}
        />
      </div>
    </SimpleForm>
  );
};

const ProjectDetailsForm = props => {
  const {
    pageState,
    action,
    handleEditAction,
    project: { comment },
    updateFormInfo,
    submitForm,
    getResponses,
    getLabels,
    basic_needs,
    onboardingSteps,
    formInfo,
    basicRequirementsBlock,
  } = props;

  const getStepInfo = (steps, key) => steps.find(step => step.key === key);

  const getStepOptions = (steps, key) => {
    const foundStep = getStepInfo(steps, key);
    return foundStep.cards.map(card => {
      if (Object.keys(card).includes('boldLabel'))
        return {
          text: `${card.label} ${card.boldLabel}`,
          key: `${card.label} ${card.boldLabel}`,
          value: card.value,
        };
      return {
        text: card.label,
        key: card.value,
        value: card.value,
      };
    });
  };

  const allTypesOptions = getStepOptions(
    onboardingSteps.basic_information.onboardingSteps,
    'type',
  );

  const allDurationOptions = getStepOptions(
    onboardingSteps.basic_information.onboardingSteps,
    'duration',
  );

  const allNeedsOptions = getStepOptions(
    onboardingSteps.basic_information.onboardingSteps,
    'basic_requirements',
  );

  const [showMore, setShowMore] = useState(true);
  const showMoreLink = comment.length > 1000;
  const currentValue = (options, text) =>
    options.find(option => option.text === text);

  const currentValues = (options, texts) =>
    options.filter(option => texts.includes(option.text));

  return (
    <SimpleForm {...props}>
      <div
        className={classnames('row px-2 mx-2 justify-content-between', {
          'basic-block': pageState[action],
        })}
      >
        <p className="t-21 text-darkgreen">Basic</p>
        <FormActions
          pageState={pageState}
          action={action}
          handleEditAction={handleEditAction}
          submitForm={submitForm}
        />
      </div>
      <div className="col-12">
        <div className="col p-0">
          <hr className="project-separator" />
        </div>
      </div>
      <div
        className={classnames('col-12', {
          'basic-details-edit': pageState[action],
          'basic-details-show': !pageState[action],
        })}
      >
        {pageState[action] ? (
          <React.Fragment>
            <TextArea
              label="Project Details"
              name="comments"
              onChange={updateFormInfo}
              hasInput={!!comment}
            />
            <div className="row">
              <div className="col-6">
                <Dropdown
                  extraClassName="additional-dropdown"
                  name="answered_questions[type]"
                  placeholder="Type"
                  value={
                    currentValue(
                      allTypesOptions,
                      getResponses('type')(getLabels)[0],
                    ) &&
                    currentValue(
                      allTypesOptions,
                      getResponses('type')(getLabels)[0],
                    ).value
                  }
                  options={allTypesOptions}
                  onChange={(field, form) => {
                    const info = _.cloneDeep(formInfo);
                    info.answered_questions.type = field.value;
                    updateFormInfo({
                      target: {
                        name: 'answered_questions',
                        value: info.answered_questions,
                      },
                    });
                  }}
                />
              </div>
              <div className="col-6">
                <Dropdown
                  extraClassName="additional-dropdown"
                  name="answered_questions[duration]"
                  placeholder="Duration"
                  value={
                    currentValue(
                      allDurationOptions,
                      getResponses('duration')(getLabels)[0],
                    ) &&
                    currentValue(
                      allDurationOptions,
                      getResponses('duration')(getLabels)[0],
                    ).value
                  }
                  options={allDurationOptions}
                  onChange={(field, form) => {
                    const info = _.cloneDeep(formInfo);
                    info.answered_questions.duration = field.value;
                    updateFormInfo({
                      target: {
                        name: 'answered_questions',
                        value: info.answered_questions,
                      },
                    });
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <Dropdown
                  extraClassName="additional-dropdown"
                  name="answered_questions[basic_requirements]"
                  placeholder="Needs"
                  fluid
                  multiple
                  value={currentValues(
                    allNeedsOptions,
                    getResponses('basic_requirements')(getLabels),
                  ).map(opt => opt.value)}
                  options={allNeedsOptions}
                  onChange={(field, form) => {
                    const info = _.cloneDeep(formInfo);
                    info.answered_questions.basic_requirements = field.value;
                    updateFormInfo({
                      target: {
                        name: 'answered_questions',
                        value: info.answered_questions,
                      },
                    });
                  }}
                />
              </div>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="row">
              <div className="col-12">
                <h5 className="t-14 text-gray-light mb-3">Project Details</h5>
                {!comment && (
                  <div className="t-14 text-black mb-4 add-info">
                    Click{' '}
                    <a
                      className="new-project"
                      onClick={() => handleEditAction(action)}
                    >
                      {'here'}
                    </a>{' '}
                    to add Project Details
                  </div>
                )}
              </div>
            </div>
            {comment && (
              <div className="row">
                <div className="col">
                  <p
                    className={classnames('t-14 text-black mb-4', {
                      'project-details': showMore,
                      'project-details-all': !showMore,
                    })}
                    style={{
                      wordBreak: 'break-word',
                    }}
                  >
                    {comment}
                  </p>
                </div>
              </div>
            )}
            {showMoreLink && (
              <div className="row">
                <div className="col">
                  <div className="t-14 text-black mb-4">
                    <a
                      className="new-project"
                      onClick={() => setShowMore(!showMore)}
                    >
                      {showMore ? 'Show All ↓' : 'Show Less ↑'}
                    </a>
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-12 col-md-4">
                <div className="row">
                  <div className="col-12">
                    <h5 className="t-14 text-gray-light mb-3">Type</h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <p className="t-14 text-black mb-4">
                      {getResponses('type')(getLabels)[0] || 'Not provided'}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="row">
                  <div className="col-12">
                    <h5 className="t-14 text-gray-light mb-3">Needs</h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    {basic_needs.length === 0 ? (
                      <p key="pending" className="t-14 text-black m-0">
                        Not provided
                      </p>
                    ) : (
                      basic_needs
                    )}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className="row">
                  <div className="col-12">
                    <h5 className="t-14 text-gray-light mb-3">Duration</h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <p className="t-14 text-black mb-4">
                      {getResponses('duration')(getLabels)[0] || 'Not provided'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </SimpleForm>
  );
};

const ProjectAdditionalInfoForm = props => {
  const {
    pageState,
    action,
    handleEditAction,
    project,
    updateFormInfo,
    submitForm,
    onboardingSteps,
    formInfo,
    getResponses,
    getLabels,
    dispatchProjectFileUpload,
  } = props;

  const getProjectStep = key =>
    project.project_onboarding_infos.find(info => info.question.key === key);

  const getProjectResponce = key => getProjectStep(key).question_response;

  const getStepInfo = (steps, key) => steps.find(step => step.key === key);

  const getStepOptions = (steps, key) => {
    const foundStep = getStepInfo(steps, key);
    return foundStep.cards.map(card => {
      if (Object.keys(card).includes('boldLabel'))
        return {
          text: `${card.label} ${card.boldLabel}`,
          key: `${card.label} ${card.boldLabel}`,
          value: card.value,
        };
      return {
        text: card.label,
        key: card.value,
        value: card.value,
      };
    });
  };

  const getDayStyle = day => {
    const deadline = moment(
      getStepInfo(onboardingSteps.basic_information.onboardingSteps, 'deadline')
        .selectedValue[0],
      'DD-MM-YYYY',
    ).startOf('day');
    const today = moment().startOf('day');

    if (day.isSame(deadline)) {
      return 'r-selected';
    }

    if (day.isSame(today)) {
      return 'today-date-cell';
    }

    return 'simple-day-cell';
  };

  const requrementsCheckHandler = (target, value) => {
    const checked = _.cloneDeep(
      formInfo.answered_questions.project_requirements,
    );
    if (target.checked) checked.push(value);
    else {
      const ind = checked.indexOf(value);
      checked.splice(ind, 1);
    }
    formInfo.answered_questions.project_requirements = checked;
    const event = {
      target: {
        name: 'answered_questions',
        value: formInfo.answered_questions,
      },
    };
    updateFormInfo(event);
  };


  const audCheckHandler = (target, value) => {
    const checked = _.cloneDeep(
      formInfo.answered_questions.audience,
    );
    if (target.checked) checked.push(value);
    else {
      const ind = checked.indexOf(value);
      checked.splice(ind, 1);
    }
    formInfo.answered_questions.audience = checked;
    const event = {
      target: {
        name: 'answered_questions',
        value: formInfo.answered_questions,
      },
    };
    updateFormInfo(event);
  };


    const videoLayoutCheckHandler = (target, value) => {
    const checked = _.cloneDeep(
      formInfo.answered_questions.video_layout,
    );
    if (target.checked) checked.push(value);
    else {
      const ind = checked.indexOf(value);
      checked.splice(ind, 1);
    }
    formInfo.answered_questions.video_layout = checked;
    const event = {
      target: {
        name: 'answered_questions',
        value: formInfo.answered_questions,
      },
    };
    updateFormInfo(event);
  };



  const additionalRequirementsValues = Object.values(project.adds).filter(
    val => val && val.length !== 0,
  );

  const additionalInfo = additionalRequirementsValues.length !== 0;
  const allToneOptions = getStepOptions(
    onboardingSteps.basic_information.onboardingSteps,
    'tone',
  );
  const allFormatOptions = getStepOptions(
    onboardingSteps.basic_information.onboardingSteps,
    'format',
  );

  const selectedTone =
    formInfo.answered_questions.tone &&
    getStepInfo(
      onboardingSteps.basic_information.onboardingSteps,
      'tone',
    ).cards.find(step => step.value === formInfo.answered_questions.tone[0]);

  const selectedFormat =
    formInfo.answered_questions.format &&
    getStepInfo(
      onboardingSteps.basic_information.onboardingSteps,
      'format',
    ).cards.find(step => step.value === formInfo.answered_questions.format[0]);

  const deadline =
    getProjectResponce('deadline')[0] &&
    moment(getProjectResponce('deadline')[0], 'YYYY-MM-DD').format(
      'MM/DD/YYYY',
    );

  const { REACT_APP_DROPBOX_KEY } = process.env;

  const currentFormat = getProjectStep('format').card[0];

  const advNeeds = getResponses('project_requirements')(getLabels).map(need => (
    <p key={need} className="t-14 text-black m-0">
      {need}
    </p>
  ));

  const audNeeds = getResponses('audience')(getLabels).map(need => (
    <p key={need} className="t-14 text-black m-0">
      {need}
    </p>
  ));

   const video_layoutNeeds = getResponses('video_layout')(getLabels).map(need => (
    <p key={need} className="t-14 text-black m-0">
      {need}
    </p>
  ));


  const [filesNotLimited, changeLimitHandler] = useState(false);

  const files = getProjectResponce('files')
    .concat(project.dropbox_urls)
    .map(
      (file, index) =>
        (index < 2 || filesNotLimited) && (
          <p className="my-1">
            <a
              key={file.name}
              href={file.url || file.link}
              target="_blank"
              className="t-14 m-0"
            >
              {file.name}
            </a>
          </p>
        ),
    );

  const newFiles =
    formInfo.answered_questions.files &&
    formInfo.dropbox_urls &&
    formInfo.answered_questions.files
      .concat(formInfo.dropbox_urls)
      .map(file => (
        <p className="my-1 asset-field">
          <a
            key={file.name}
            href={file.url || file.link}
            target="_blank"
            className="t-14 m-0"
          >
            {file.name}
          </a>
          <i
            className="cursor-pointer icon icon-close m-0 t-20 delete-asset"
            onClick={() => {
              const formAnswers = formInfo.answered_questions;
              updateFormInfo({
                target: {
                  name: 'answered_questions',
                  value: {
                    ...formInfo.answered_questions,
                    files: formAnswers.files.filter(
                      addedFile => file.url !== addedFile.url,
                    ),
                  },
                },
              });
            }}
          />
        </p>
      ));

  const minDate = new Date();

  const showAdds = additionalInfo ? (
    <React.Fragment>
      <div className="row py-3">
        <div className="col-12 col-md-4">
          <div className="row">
            <div className="col-12">
              <h5 className="t-14 text-gray-light mb-3">Deadline</h5>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <p className="t-14 text-black mb-4">
                {deadline || 'Not provided'}
              </p>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="row">
            <div className="col-12">
              <h5 className="t-14 text-gray-light mb-3">Target Audience</h5>
                {audNeeds && audNeeds.length === 0 ? (
                <p key="Not_provided_adv_needs" className="t-14 text-black m-0">
                  Not provided
                </p>
              ) : (
                audNeeds
              )}
            </div>
          </div>
       {/*   <div className="row">
            <div className="col">
              <p className="t-14 text-black mb-4">
                {getResponses('tone')(getLabels)[0] || 'Not provided'}
              </p>
            </div>
          </div>*/}
        </div>
        <div className="col-12 col-md-4">
          <div className="row">
            <div className="col-12">
              <h5 className="t-14 text-gray-light mb-3">Quantity</h5>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <p className="t-14 text-black mb-4">
                {getResponses('series')(getLabels)[0] || 'Not provided'}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="row py-3">
        <div className="col-12 col-md-4">
          <div className="row">
            <div className="col-12">
              <h5 className="t-14 text-gray-light mb-3">Video Layouts</h5>
                {video_layoutNeeds && video_layoutNeeds.length === 0 ? (
                <p key="Not_provided_adv_needs" className="t-14 text-black m-0">
                  Not provided
                </p>
              ) : (
                video_layoutNeeds
              )}
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4 adv-requirements-row">
          <div className="row">
            <div className="col-12">
              <h5 className="t-14 text-gray-light mb-3">
                My Project Also Needs
              </h5>
            </div>
          </div>
          <div className="row">
            <div className="col adv-requirements-col">
              {advNeeds && advNeeds.length === 0 ? (
                <p key="Not_provided_adv_needs" className="t-14 text-black m-0">
                  Not provided
                </p>
              ) : (
                advNeeds
              )}
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="row">
            <div className="col-12">
              <h5 className="t-14 text-gray-light mb-3">Files and Assets</h5>
            </div>
          </div>
          <div className="row">
            <div className="col all-files-with-show-more">
              {files && files.length === 0 ? (
                <p key="Not_provided_files" className="t-14 text-black m-0">
                  Not provided
                </p>
              ) : (
                files
              )}
              {files &&
                files.length > 2 && (
                  <a
                    onClick={e => {
                      e.preventDefault();
                      changeLimitHandler(!filesNotLimited);
                    }}
                    href="/"
                    className="t-14 m-0"
                  >
                    {filesNotLimited ? 'Show less ↑' : 'Show all files ↓'}
                  </a>
                )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <div className="row">
        <div className="col-12">
          <h5 className="t-14 text-gray-light mb-3">
            To have a more in-depth conversation, add detail here.
          </h5>
        </div>
      </div>
      <div className="row edit-additional-information-row">
        <div className="col">
          <Button
            title="Set Additional Information"
            className="btn btn-md t-14 btn-primary"
            onClick={() => {
              handleEditAction('editAdditionalInfo');
            }}
          />
        </div>
      </div>
    </React.Fragment>
  );

  const datePickerValue = formInfo.answered_questions.deadline
    ? new Date(formInfo.answered_questions.deadline)
    : null;
  const [dateFormat, toggleHideDelimeters] = useState(
    datePickerValue == null ? 'MM' : 'MM/dd/y',
  );
  const [placeholder, setPlaceholder] = useState(
    datePickerValue == null ? 'Deadline' : '--',
  );

  return (
    <SimpleForm {...props}>
      <div className="row px-2 mb-3 mx-2 justify-content-between adds-block">
        <p className="t-21 text-darkgreen">Additional Information</p>
        {(additionalInfo || pageState[action]) && (
          <FormActions
            pageState={pageState}
            action={action}
            handleEditAction={handleEditAction}
            submitForm={submitForm}
          />
        )}
      </div>
      <div className="col-12">
        <div className="col p-0">
          <hr className="project-separator" />
        </div>
      </div>
      <div className="col-12 additional-information">
        <React.Fragment>
          {pageState[action] ? (
            <React.Fragment>
              <div className="row">
                <div className="col-6">
                  <DatePicker
                    containerClassName="additional-dropdown"
                    clearIcon={null}
                    format={dateFormat}
                    calendarType="US"
                    monthPlaceholder={placeholder}
                    minDate={new Date()}
                    onCalendarOpen={() => {
                      toggleHideDelimeters('MM/dd/y');
                      setPlaceholder('--');
                    }}
                    onCalendarClose={() => {
                      if (!formInfo.answered_questions.deadline) {
                        toggleHideDelimeters('MM');
                        setPlaceholder('Deadline');
                      }
                    }}
                    onChange={date => {
                      const info = _.cloneDeep(formInfo);
                      info.answered_questions.deadline = date;
                      updateFormInfo({
                        target: {
                          name: 'answered_questions',
                          value: info.answered_questions,
                        },
                      });
                    }}
                    label="Deadline"
                    name="deadline"
                    value={datePickerValue}
                  />
                </div>
<div className="col-6">
                  <p className="t-14 font-weight-bold text-darkgreen">
                    Quantity
                  </p>
                  <div className="row">
                    <div className="col-6">
                      <div className="custom-control additional-input custom-radio inline-radio">
                        <input
                          type="radio"
                          className="custom-control-input"
                          name="series"
                          id="series-single"
                          onChange={e => {
                            const info = _.cloneDeep(formInfo);
                            info.answered_questions.series = [e.target.value];
                            updateFormInfo({
                              target: {
                                name: 'answered_questions',
                                value: info.answered_questions,
                              },
                            });
                          }}
                          defaultChecked={getProjectResponce('series').includes(
                            'single',
                          )}
                          value="single"
                        />
                        <label
                          className="custom-control-label inline-radio t-13"
                          htmlFor="series-single"
                        >
                          Single Video
                        </label>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="custom-control additional-input custom-radio inline-radio">
                        <input
                          type="radio"
                          className="custom-control-input"
                          name="series"
                          id="series-series"
                          onChange={e => {
                            const info = _.cloneDeep(formInfo);
                            info.answered_questions.series = [e.target.value];
                            updateFormInfo({
                              target: {
                                name: 'answered_questions',
                                value: info.answered_questions,
                              },
                            });
                          }}
                          value="Multiple Videos"
                          defaultChecked={getProjectResponce('series').includes(
                            'Multiple Videos',
                          )}
                        />
                        <label
                          className="custom-control-label inline-radio t-13"
                          htmlFor="series-series"
                        >
                          Multiple Videos
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row my-4 reverse-column">
                

                                <div className="col-6">
                  <p className="t-14 font-weight-bold text-darkgreen">
                    Video Layout
                  </p>
                  <div className="row">
                    <div className="col-6">
                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="16:9"
                          id="16:9"
                          onChange={e => {
                            videoLayoutCheckHandler(e.target, '16:9');
                          }}
                          value="16:9"
                          defaultChecked={getProjectResponce(
                            'video_layout',
                          ).includes('16:9')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="16:9"
                        >
                          16:9
                        </label>
                      </div>
                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="9:16"
                          id="9:16"
                          onChange={e => {
                            videoLayoutCheckHandler(e.target, '9:16');
                          }}
                          value="9:16"
                          defaultChecked={getProjectResponce(
                            'video_layout',
                          ).includes('9:16')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="9:16"
                        >
                          9:16
                        </label>
                      </div>
                     
                       <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="4:5"
                          id="4:5"
                          onChange={e => {
                            videoLayoutCheckHandler(e.target, '4:5');
                          }}
                          value="4:5"
                          defaultChecked={getProjectResponce(
                            'video_layout',
                          ).includes('4:5')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="4:5"
                        >
                          4:5
                        </label>
                      </div>

                    </div>
                    <div className="col-6">

                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="1:1"
                          id="1:1"
                          onChange={e => {
                            videoLayoutCheckHandler(e.target, '1:1');
                          }}
                          value="1:1"
                          defaultChecked={getProjectResponce(
                            'video_layout',
                          ).includes('1:1')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="1:1"
                        >
                          1:1
                        </label>
                      </div>

                       <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="2:3"
                          id="2:3"
                          onChange={e => {
                            videoLayoutCheckHandler(e.target, '2:3');
                          }}
                          value="2:3"
                          defaultChecked={getProjectResponce(
                            'video_layout',
                          ).includes('2:3')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="2:3"
                        >
                          2:3
                        </label>
                      </div>


                       <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="Google Specific Requirements"
                          id="Google Specific Requirements"
                          onChange={e => {
                            videoLayoutCheckHandler(e.target, 'Google Specific Requirements');
                          }}
                          value="Google Specific Requirements"
                          defaultChecked={getProjectResponce(
                            'video_layout',
                          ).includes('Google Specific Requirements')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="Google Specific Requirements"
                        >
                          Google Specific Requirements
                        </label>
                      </div>


                    </div>
                  </div>




                 {/* <Dropdown
                    extraClassName="additional-dropdown"
                    name="answered_questions[format]"
                    placeholder="Video Layout"
                    value={formInfo.answered_questions.format}
                    options={allFormatOptions}
                    onChange={(field, form) => {
                      const info = _.cloneDeep(formInfo);
                      info.answered_questions.format = field.value;
                      updateFormInfo({
                        target: {
                          name: 'answered_questions',
                          value: info.answered_questions,
                        },
                      });
                    }}
                  />*/}
                </div>
                {/*
                 <div className="col-6">
                  <Dropdown
                    extraClassName="additional-dropdown"
                    name="answered_questions[tone]"
                    placeholder="Target Audience"
                    value={formInfo.answered_questions.tone}
                    options={allToneOptions}
                    onChange={(field, form) => {
                      const info = _.cloneDeep(formInfo);
                      info.answered_questions.tone = field.value;
                      updateFormInfo({
                        target: {
                          name: 'answered_questions',
                          value: info.answered_questions,
                        },
                      });
                    }}
                  />
                </div> */}

                <div className="col-6">
                  <p className="t-14 font-weight-bold text-darkgreen">
                    Target Audience
                  </p>
                  <div className="row">
                    <div className="col-6">
                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="Generation Z"
                          id="Generation Z"
                          onChange={e => {
                            audCheckHandler(e.target, 'Generation Z');
                          }}
                          value="Generation Z"
                          defaultChecked={getProjectResponce(
                            'audience',
                          ).includes('Generation Z')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="Generation Z"
                        >
                          Generation Z
                        </label>
                      </div>
                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="Generation X"
                          id="Generation X"
                          onChange={e => {
                            audCheckHandler(e.target, 'Generation X');
                          }}
                          value="Generation X"
                          defaultChecked={getProjectResponce(
                            'audience',
                          ).includes('Generation X')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="Generation X"
                        >
                          Generation X
                        </label>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="Baby Boomers"
                          id="Baby Boomers"
                          onChange={e => {
                            audCheckHandler(e.target, 'Baby Boomers');
                          }}
                          value="Baby Boomers"
                          defaultChecked={getProjectResponce(
                            'audience',
                          ).includes('Baby Boomers')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="Baby Boomers"
                        >
                          Baby Boomers
                        </label>
                      </div>

                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="Millenials"
                          id="Millenials"
                          onChange={e => {
                            audCheckHandler(e.target, 'Millenials');
                          }}
                          value="Millenials"
                          defaultChecked={getProjectResponce(
                            'audience',
                          ).includes('Millenials')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="Millenials"
                        >
                          Millenials
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row my-4">
                <div className="col-6 project-needs">
                  <p className="t-14 font-weight-bold text-darkgreen">
                    My Project Also Needs
                  </p>
                  <div className="row">
                    <div className="col-6">
                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="script_subtitles"
                          id="script_subtitles"
                          onChange={e => {
                            requrementsCheckHandler(
                              e.target,
                              'script_subtitles',
                            );
                          }}
                          value="script_subtitles"
                          defaultChecked={getProjectResponce(
                            'project_requirements',
                          ).includes('script_subtitles')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="script_subtitles"
                        >
                          Subtitles
                        </label>
                      </div>
                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="Creative Concepting/Storyboard"
                          id="Creative Concepting/Storyboard"
                          onChange={e => {
                            requrementsCheckHandler(e.target, 'Creative Concepting/Storyboard');
                          }}
                          value="Creative Concepting/Storyboard"
                          defaultChecked={getProjectResponce(
                            'project_requirements',
                          ).includes('Creative Concepting/Storyboard')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="Creative Concepting/Storyboard"
                        >
                          Creative Concepting/Storyboard
                        </label>
                      </div>
                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="Music/Audio"
                          id="Music/Audio"
                          onChange={e => {
                            requrementsCheckHandler(e.target, 'Music/Audio');
                          }}
                          value="Music/Audio"
                          defaultChecked={getProjectResponce(
                            'project_requirements',
                          ).includes('Music/Audio')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="Music/Audio"
                        >
                          Music/Audio
                        </label>
                      </div>
                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="Copywriting"
                          id="Copywriting"
                          onChange={e => {
                            requrementsCheckHandler(e.target, 'Copywriting');
                          }}
                          value="Copywriting"
                          defaultChecked={getProjectResponce(
                            'project_requirements',
                          ).includes('Copywriting')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="Copywriting"
                        >
                          Copywriting
                        </label>
                      </div>
                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="Creative Best Practices"
                          id="Creative Best Practices"
                          onChange={e => {
                            requrementsCheckHandler(
                              e.target,
                              'Creative Best Practices',
                            );
                          }}
                          value="Creative Best Practices"
                          defaultChecked={getProjectResponce(
                            'project_requirements',
                          ).includes('Creative Best Practices')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="Creative Best Practices"
                        >
                          Creative Best Practices
                        </label>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="Stock Assets"
                          id="Stock Assets"
                          onChange={e => {
                            requrementsCheckHandler(e.target, 'Stock Assets');
                          }}
                          value="Stock Assets"
                          defaultChecked={getProjectResponce(
                            'project_requirements',
                          ).includes('Stock Assets')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="Stock Assets"
                        >
                          Stock Assets
                        </label>
                      </div>
                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="Additional Ratios/Formats"
                          id="Additional Ratios/Formats"
                          onChange={e => {
                            requrementsCheckHandler(e.target, 'Additional Ratios/Formats');
                          }}
                          value="Additional Ratios/Formats"
                          defaultChecked={getProjectResponce(
                            'project_requirements',
                          ).includes('Additional Ratios/Formats')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="Additional Ratios/Formats"
                        >
                          Additional Ratios/Formats
                        </label>
                      </div>
                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="voiceover"
                          id="voiceover"
                          onChange={e => {
                            requrementsCheckHandler(e.target, 'voiceover');
                          }}
                          value="voiceover"
                          defaultChecked={getProjectResponce(
                            'project_requirements',
                          ).includes('voiceover')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="voiceover"
                        >
                          Voiceover
                        </label>
                      </div>

                      <div className="custom-control additional-input custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          name="Language Translation / Localization"
                          id="Language Translation / Localization"
                          onChange={e => {
                            requrementsCheckHandler(
                              e.target,
                              'Language Translation / Localization',
                            );
                          }}
                          value="Language Translation / Localization"
                          defaultChecked={getProjectResponce(
                            'project_requirements',
                          ).includes('Language Translation / Localization')}
                        />
                        <label
                          className="custom-control-label t-13"
                          htmlFor="Language Translation / Localization"
                        >
                          Language Translation / Localization
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 files">
                  <p className="t-14 font-weight-bold text-darkgreen">
                    Files and Assets
                  </p>
                  <div className="row px-3">
                    {onboardingSteps.isUploadingAttachment && (
                      <p className="t-14 asset-field">Loading...</p>
                    )}
                    {newFiles}
                    <div className="asset-block p-3">
                      <label
                        htmlFor="assets-input"
                        className="t-14 m-0 add-assets"
                      >
                        <img src={fileIcon} />
                        <p>Add Files</p>
                      </label>
                      <input
                        id="assets-input"
                        name="files"
                        onChange={event => {
                          event.preventDefault();
                          const file = _.head(event.target.files);
                          const step = 'files';
                          const overviewStep = 'basic_information';

                          if (!file) {
                            return;
                          }

                          dispatchProjectFileUpload(
                            overviewStep,
                            step,
                            file,
                            'attachment',
                            updateFormInfo,
                            formInfo,
                          );
                        }}
                        type="file"
                      />
                    </div>
                    <div className="row p-3">
                      <div className="col-12 p-0">
                        <a className="d-flex flex-row no-decoration">
                          <DropboxChooser
                            appKey={REACT_APP_DROPBOX_KEY}
                            className="dropbox_custom_class"
                            folderselect
                            multiselect
                            openOnClick
                            onSuccess={selectedFolders => {
                              const formAnswers = formInfo.answered_questions;
                              updateFormInfo({
                                target: {
                                  name: 'answered_questions',
                                  value: {
                                    ...formInfo.answered_questions,
                                    files: selectedFolders
                                      .map(f => ({
                                        name: f.name,
                                        url: f.link,
                                      }))
                                      .concat(formAnswers.files),
                                  },
                                },
                              });
                            }}
                          >
                            <span
                              className="t-14 align-self-center dropbox-assets"
                              style={{ color: '#259F96' }}
                            >
                              <img src={dropboxIcon} />
                              Connect to Dropbox
                            </span>
                          </DropboxChooser>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ) : (
            showAdds
          )}
        </React.Fragment>
      </div>
    </SimpleForm>
  );
};

const ProjectReferencesForm = props => {
  const {
    pageState,
    action,
    handleEditAction,
    updateFormInfo,
    submitForm,
    formInfo,
    project,
  } = props;
  const referenceCards = (() => {
    if (formInfo.references) {
      return formInfo.references
        .filter(ref => !ref._destroy)
        .map((r, index) => (
          <ReferencesCard
            updateFormInfo={updateFormInfo}
            editable={pageState[action]}
            reference={r}
            formInfo={formInfo}
            referenceIndex={index}
            key={r.internal_id}
          />
        ))
        .reduce((acc, x) => (acc === null ? [x] : [acc, x]), null);
    }

    return [];
  })();

  return (
    <SimpleForm {...props}>
      <div className="row px-2 mx-2 mt-5 justify-content-between refs-block">
        <p className="t-21 text-darkgreen mb-0">References</p>
        {formInfo.references && (
          <FormActions
            pageState={pageState}
            action={action}
            handleEditAction={handleEditAction}
            submitForm={submitForm}
            updateFormInfo={updateFormInfo}
            project={project}
          />
        )}
      </div>
      <div className="col-12">
        <div className="col p-0">
          <hr className="project-separator" />
        </div>
      </div>
      <div className="col-12">
        {formInfo.references ? (
          <React.Fragment>
            <FieldArray
              name="references"
              render={({ values }) => (
                <React.Fragment>{referenceCards}</React.Fragment>
              )}
            />
            {pageState[action] && (
              <a
                className="t-14"
                onClick={e => {
                  e.preventDefault();
                  const refs = formInfo.references.concat({
                    internal_id: Math.floor(
                      Math.random() * Math.floor(100000000),
                    ),
                    link: '',
                    checkboxes: [],
                  });
                  const event = { target: { name: 'references', value: refs } };
                  updateFormInfo(event);
                }}
                href="/"
              >
                Add Another Reference
              </a>
            )}
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="row">
              <div className="col-12">
                <h5 className="t-14 text-gray-light mb-3">
                  Have any projects you'd like to use as inspiration?
                </h5>
              </div>
            </div>
            <div className="row">
              <div className="col add-reference-button-container">
                <Button
                  title="Add Reference"
                  onClick={() => {
                    const refs = [
                      {
                        internal_id: Math.floor(
                          Math.random() * Math.floor(100000000),
                        ),
                        link: '',
                        checkboxes: [],
                      },
                    ];
                    const event = {
                      target: { name: 'references', value: refs },
                    };
                    updateFormInfo(event);
                    handleEditAction('editReferences');
                  }}
                  className="btn btn-md t-14 btn-primary add-reference-button"
                />
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </SimpleForm>
  );
};

const ProjectPictureForm = props => {
  const {
    project: { project_picture },
    updateFormInfo,
    submitForm,
    formInfo,
    project,
  } = props;

  const [hideLabel, setHideLabel] = useState(false);

  return (
    <SimpleForm {...props}>
      <AvatarChooser
        hideLabel={hideLabel}
        setHideLabel={setHideLabel}
        updateFormInfo={updateFormInfo}
        formInfo={formInfo}
        submitForm={submitForm}
        project={project}
        name="projectPicture"
        label={project_picture ? 'Edit Cover' : 'Add Cover'}
        alt="Project Picture"
        pictureClassName={`edit-profile__content-profile-pic ${project_picture &&
          'edit-profile__content-profile-pic-with-border'} profile-background ${
          project_picture ? 'edit' : 'add'
        }`}
        labelClassName="edit-profile__content-profile-pic-label"
      />
    </SimpleForm>
  );
};

const SimpleForm = props => (
  <Form autoComplete="off" noValidate>
    {props.children}
  </Form>
);

const ProjectDetailsFormWithFormik = withFormik({
  enableReinitialize: true,
  handleSubmit: (
    values,
    { props: { submitForm, handleEditAction, action, project, formInfo } },
  ) => {
    const answered_questions = {
      answered_questions: Object.entries(values.answered_questions).map(
        question => ({
          key: question[0],
          question_response:
            question[1] instanceof Array ? question[1] : [question[1]],
        }),
      ),
    };

    submitForm({
      projectData: {
        comment: values.comments,
        dropbox_urls: formInfo.dropbox_urls,
        ...answered_questions,
      },
      dropbox_urls: formInfo.dropbox_urls,
      id: project.id,
    });
    handleEditAction(action);
  },
  mapPropsToValues: ({ formInfo }) => ({
    comments: formInfo.comments,
    answered_questions: _.cloneDeep(formInfo.answered_questions),
  }),
  validateOnBlur: false,
  validateOnChange: false,
  validationSchema: () => Yup.object({}),
  displayName: 'ProjectDetailsForm',
})(ProjectDetailsForm);

const ProjectNameFormWithFormik = withFormik({
  enableReinitialize: true,
  handleSubmit: (
    values,
    { props: { submitForm, handleEditAction, action, project } },
  ) => {
    submitForm({
      projectData: {
        project_name: values.projectName,
      },
      id: project.id,
    });
    handleEditAction(action);
  },
  mapPropsToValues: ({ formInfo: { projectName } }) => ({
    projectName,
  }),
  validateOnBlur: false,
  validateOnChange: false,
  validationSchema: () => Yup.object({}),
  displayName: 'ProjectNameForm',
})(ProjectNameForm);

const ProjectAdditionalInfoFormWithFormik = withFormik({
  enableReinitialize: true,
  handleSubmit: (
    values,
    { props: { submitForm, handleEditAction, action, project, formInfo } },
  ) => {
    const answered_questions = {
      answered_questions: Object.entries(values.answered_questions).map(
        question => ({
          key: question[0],
          question_response:
            question[1] instanceof Array ? question[1] : [question[1]],
        }),
      ),
    };

    submitForm({
      projectData: {
        dropbox_urls: formInfo.dropbox_urls,
        ...answered_questions,
      },
      id: project.id,
    });
    handleEditAction(action);
  },
  mapPropsToValues: ({ formInfo }) => ({
    answered_questions: _.cloneDeep(formInfo.answered_questions),
  }),
  validateOnBlur: false,
  validateOnChange: false,
  validationSchema: () => Yup.object({}),
  displayName: 'ProjectAdditionalInfoForm',
})(ProjectAdditionalInfoForm);

const ProjectReferencesFormWithFormik = withFormik({
  enableReinitialize: true,
  handleSubmit: (
    values,
    { props: { submitForm, handleEditAction, action, project } },
  ) => {
    submitForm({
      projectData: {
        references_attributes: values.references,
      },
      id: project.id,
    });
    handleEditAction(action);
  },
  mapPropsToValues: ({ formInfo: references }) => _.cloneDeep(references),
  validateOnBlur: false,
  validateOnChange: false,
  validationSchema: () =>
    Yup.object().shape({
      references: Yup.array().of(
        Yup.object().shape({
          link: Yup.string().required('Please enter a URL'),
          internal_id: Yup.number(),
        }),
      ),
    }),
  displayName: 'ProjectReferencesForm',
})(ProjectReferencesForm);

const ProjectPictureFormWithFormik = withFormik({
  enableReinitialize: true,
  handleSubmit: (values, { props: { submitForm, project } }) => {
    submitForm({
      projectData: {
        project_picture: values.projectPicture,
      },
      id: project.id,
    });
  },
  mapPropsToValues: ({ formInfo: { projectPicture } }) => ({
    projectPicture,
  }),
  validateOnBlur: false,
  validateOnChange: false,
  validationSchema: () => Yup.object({}),
  displayName: 'ProjectPictureForm',
})(ProjectPictureForm);

const YupString = Yup.string().required('Required');

SimpleForm.propTypes = {
  children: PropTypes.element,
};

ProjectDetailsForm.propTypes = {
  pageState: PropTypes.object,
  action: PropTypes.string,
  project: PropTypes.object,
  updateFormInfo: PropTypes.func,
  submitForm: PropTypes.func,
  handleEditAction: PropTypes.func,
};

ProjectPictureForm.propTypes = {
  project: PropTypes.object,
  updateFormInfo: PropTypes.func,
  submitForm: PropTypes.func,
};

ProjectView.propTypes = {
  getNotRequired: PropTypes.func,
  getaudRequired: PropTypes.func,
  video_layoutRequired: PropTypes.func,
  getResponses: PropTypes.func,
  getFormats: PropTypes.func,
  project: PropTypes.object,
  children: PropTypes.object,
  getLabels: PropTypes.func,
  handleSubmitDraft: PropTypes.func,
  handleAddProjectFileResources: PropTypes.func,
  handleEditAction: PropTypes.func,
  updateFormInfo: PropTypes.func,
};

FormActions.propTypes = {
  pageState: PropTypes.object,
  action: PropTypes.string,
  handleEditAction: PropTypes.func,
};

export default ProjectView;



// WEBPACK FOOTER //
// ./src/components/ProjectView/ProjectView.js